<template>
    <div>
      <router-view></router-view>
    </div>
</template>

<script>
export default {};
</script>

<style>
.cardArticle{
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsElectron/Templent_CardsElectron.vue